// @flow

import moveEstimateCaveat from '../../../Services/moveEstimateCaveat';
import type { MoveEstimateCaveatParams } from '../../../types';

export default (params: MoveEstimateCaveatParams) => async (dispatch: Function) => dispatch(moveEstimateCaveat(params))